import { c as _c } from "react/compiler-runtime";
import { Card, CardContent } from '@achra/ui/card';
import { Skeleton } from '@achra/ui/skeleton';
function ConfirmationStepSkeleton() {
  const $ = _c(5);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Skeleton className="size-10 rounded-lg" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Skeleton className="h-6 w-56" />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex flex-col items-center gap-4">{t0}<div className="flex flex-col items-center gap-2">{t1}<div className="flex flex-col gap-1"><Skeleton className="h-4.5 w-full max-w-64" /><Skeleton className="h-4.5 w-full max-w-56" /><Skeleton className="h-4.5 w-full max-w-48" /></div></div></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Card className="bg-background border-border relative min-h-23 w-full rounded-lg p-3 shadow-none"><CardContent className="flex flex-col items-center gap-2 px-0"><div className="flex w-fit items-center gap-2"><Skeleton className="size-6 shrink-0 rounded-md" /><Skeleton className="h-5 w-24" /></div><Skeleton className="h-4 w-full max-w-40" /></CardContent></Card>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Card className="bg-background border-border mt-16 w-full self-center rounded-lg p-6 shadow-xs md:max-w-156"><CardContent className="flex flex-col items-center gap-6 px-0">{t2}<div className="grid w-full grid-cols-1 gap-4 sm:grid-cols-2">{t3}<Card className="bg-background border-border relative min-h-23 w-full rounded-lg p-3 shadow-none"><CardContent className="flex flex-col items-center gap-2 px-0"><div className="flex w-fit items-center gap-2"><Skeleton className="size-6 shrink-0 rounded-md" /><Skeleton className="h-5 w-24" /></div><Skeleton className="h-4 w-full max-w-40" /></CardContent></Card></div></CardContent></Card>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}
export { ConfirmationStepSkeleton };